import { Schema, arrayOf } from 'normalizr'

export const cma = new Schema('cma')
export const arrayOfCma = arrayOf(cma)
